import { render, staticRenderFns } from "./GoodsXfdetail.vue?vue&type=template&id=69212dea&"
import script from "./GoodsXfdetail.vue?vue&type=script&lang=js&"
export * from "./GoodsXfdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports